var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutus-details"},[_c('my-nav',[_vm._v(_vm._s(_vm.title))]),_c('van-image',{staticClass:"van-img",attrs:{"src":require('@/assets/images/aboutus_banner.png')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }